export default "__VITE_ASSET__BcsBRf5i__"